import React from 'react';

import { AgFinancingFile } from '@indigo-ag/schema';
import { DocumentCard } from 'shared';
import { MediumLightTitle } from '@indigo-ag/component-module';
import i18next from 'i18next';

interface CARListProps {
  carList: AgFinancingFile[];
}

export const CARList: React.FunctionComponent<CARListProps> = ({ carList }) => {
  return carList && carList.length ? (
    <>
      <div style={{ marginBottom: 40 }}>
        <MediumLightTitle style={{ marginBottom: 24 }}>{i18next.t('CARDocuments')}</MediumLightTitle>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {carList.map(doc => (
            <div style={{ marginRight: 10, maxWidth: '400px' }} key={doc.id}>
              <DocumentCard key={doc.id} document={doc} />
            </div>
          ))}
        </div>
      </div>
    </>
  ) : null;
};
